import { FILTER_PAGE_ALL_EVENT } from './constants'

const initialState = {
  date: '',
  event: null,
}

export const getFilterPageAllEvent = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_PAGE_ALL_EVENT:
      return {
        ...state,
        page: action.page,
        event: action.event,
      }
    default:
      return state
  }
}
